module.exports = ".event-detail {\n  padding-top: 15px; }\n"